import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { EventUser } from "../../model/EventUser"
import { getEventUsersAsync, deleteEventUserAsync } from './currentEventUsersAPI'
import { RootState } from '../../app/store';
import { addEventUserAsync } from '../addEventUser/currentEventUserSlice'
import { removeItemAtIndex } from '../../utils/arrayUtils';
import { insertEventUserAsync, SaveEventUserDto } from '../addEventUser/AddEventUserAPI';

export interface CurrentEventUsersState {
    eventUsers: EventUser[]
    status: 'idle' | 'loading' | 'failed'
    retrievedFromServer: boolean
}

const initialState: CurrentEventUsersState = {
    eventUsers: [],
    status: 'idle',
    retrievedFromServer: false
}

export interface GetEventUsersRequest {
    partyEventId: number
    token: string
}

export interface DeleteEventUserRequest {
  partyEventId: number
  token: string
  email: string
}
type ItemWithEmail = {
  email: string
}

export interface ChangeAttendingStatusRequest {
  token: string
  email: string
  attendingStatus: number
  partyEventId: number
  alias: string | null
}

export const findItemIndexByEmail = <TItem extends ItemWithEmail>(
  items: TItem[],
  email: string
) => {
  return items.findIndex((item: TItem) => item.email === email)
}


// The function below is called a thunk and allows us to perform async logic. It
// can be dispatched like a regular action: `dispatch(incrementAsync(10))`. This
// will call the thunk with the `dispatch` function as the first argument. Async
// code can then be executed and other actions can be dispatched. Thunks are
// typically used to make async requests.
export const loadEventUsersAsync = createAsyncThunk(
    'currentEventUsers/fetchEventUsers',
    async (request: GetEventUsersRequest) => {
      const response = await getEventUsersAsync(request.partyEventId, request.token)
      // The value we return becomes the `fulfilled` action payload
      return response;
    }
  );


  export const removeEventUserAsync = createAsyncThunk(
    'currentEventUsers/deleteEventUser',
    async (request: DeleteEventUserRequest) => {
      
      const response = await deleteEventUserAsync(request.partyEventId, request.email, request.token)
      if (response) {
        return request.email
      }
      // The value we return becomes the `fulfilled` action payload
      return null
    }
  );

  export const changeAttendingStatusAsync = createAsyncThunk(
    'currentEventUsers/changeAttendingStatus',
    async (request:ChangeAttendingStatusRequest ) => {
      let saveEventUserDto : SaveEventUserDto = {
        alias: request.alias ?? '',
        email: request.email,
        partyEventId: request.partyEventId,
        attendingStatus: request.attendingStatus
      }
       const response = await insertEventUserAsync (saveEventUserDto, request.token)
       if ( response) {
        return request
       }
    }
  );
export const currentEventUsersSlice = createSlice({
    name: 'currentEventUsers',
    initialState: initialState,
    reducers: {

    },
    extraReducers: (builder) => {
        builder
        .addCase(loadEventUsersAsync.pending, (state) => {
            state.status = 'loading';
          })
          .addCase(loadEventUsersAsync.fulfilled, (state, action) => {
            state.retrievedFromServer = true
            state.status = 'idle';
            state.eventUsers = action.payload;
          })
          .addCase(loadEventUsersAsync.rejected, (state) => {
            state.status = 'failed';
          })
          .addCase(addEventUserAsync.fulfilled, (state, action) => {
            if (action.payload != null)  {
              const index = findItemIndexByEmail(state.eventUsers, action.payload.email)
              if (index<0) {
                state.eventUsers.push(action.payload) 
              }
              else {
                let existingAttendee = state.eventUsers [index]
                existingAttendee.alias = action.payload.alias
                existingAttendee.attendingStatus = action.payload.attendingStatus
              }
            }
          })
          .addCase(removeEventUserAsync.pending, (state) => {
            state.status = 'loading';
          })
          .addCase(removeEventUserAsync.fulfilled, (state, action) => {
            state.status = 'idle';
            if (action.payload) {
              const index = findItemIndexByEmail(state.eventUsers, action.payload)
              state.eventUsers = removeItemAtIndex(state.eventUsers, index)
            }
          })
          .addCase(changeAttendingStatusAsync.pending, (state) => {
            state.status = 'loading';
          })
          .addCase( changeAttendingStatusAsync.fulfilled, (state, action) => {
            state.status = 'idle';
            if (action.payload) {
              const index = findItemIndexByEmail(state.eventUsers, action.payload.email)
              state.eventUsers[index].attendingStatus=action.payload.attendingStatus
            }
          })
          .addCase(changeAttendingStatusAsync.rejected, (state) => {
            state.status = 'failed';
          }
        )
    }
})

export const selectCurrentEventUsers = (state: RootState) => state.currentEventUsers.eventUsers
export default currentEventUsersSlice.reducer